module.exports = "/**\r\n * Paste or drop some JavaScript here and explore\r\n * the syntax tree created by chosen parser.\r\n * You can use all the cool new features from ES6\r\n * and even more. Enjoy!\r\n */\r\n\r\nlet tips = [\r\n  \"Click on any AST node with a '+' to expand it\",\r\n\r\n  \"Hovering over a node highlights the \\\r\n   corresponding part in the source code\",\r\n\r\n  \"Shift click on an AST node expands the whole substree\"\r\n];\r\n\r\nfunction printTips() {\r\n  tips.forEach((tip, i) => console.log(`Tip ${i}:` + tip));\r\n}\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/parsers/js/codeExample.txt
 ** module id = ./src/parsers/js/codeExample.txt
 ** module chunks = 0
 **/